export default __webpack_public_path__ + "static/media/dark-lock-ill.ba6314c0.png";